import { CommonModule } from '@angular/common';
import { Component, NgModule, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { HdmuiDialogOptions } from '@heidelberg/hdmui-angular';
import { TranslateModule } from '@ngx-translate/core';
import { FooterDialogsActions } from '@data-terminal/shared-models/dialogs/dialogs';

@Component({
    selector: 'data-terminal-footer-leave-dialog',
    templateUrl: './footer-leave-dialog.component.html',
    styleUrls: ['./footer-leave-dialog.component.scss'],
    standalone: false,
})
export class FooterLeaveDialogComponent {
    private readonly dialogRef = inject<MatDialogRef<FooterLeaveDialogComponent>>(MatDialogRef);

    public readonly option = HdmuiDialogOptions.OPTION_NO_BUTTON;

    public readonly END_SHIFT = FooterDialogsActions.END_SHIFT;
    public readonly SIGN_OFF_WORKSTATION = FooterDialogsActions.SIGN_OFF_WORKSTATION;
    public readonly MANAGE_ASSISTANTS = FooterDialogsActions.MANAGE_ASSISTANTS;
    public readonly CANCEL = FooterDialogsActions.CANCEL;

    public onButtonClick(action: FooterDialogsActions | false): void {
        this.dialogRef.close(action);
    }
}

@NgModule({
    declarations: [FooterLeaveDialogComponent],
    exports: [FooterLeaveDialogComponent],
    imports: [CommonModule, MatButtonModule, TranslateModule],
})
export class FooterLeaveDialogModule {}
